import { I as Icon, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';
import 'styled-components';

var FacebookIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 26 26" }),
    React.createElement("path", { d: "M10.5 23v-8.8H6.8v-3.8h3.8V8c0-3.4 2.1-5 5.1-5 1.5 0 2.6.1 3 .1v3.5h-2.1c-1.6 0-2 .8-2 1.9v2h4.8L18 14.2h-3.4V23h-4.1z" }))); };

export { FacebookIcon as default };
